<div class="relative w-full bg-white p-12 shadow-lg mt-[80px]">
    <div class="max-w-7xl mx-auto flex items-center justify-start">
        <h1 class="text-3xl font-bold text-gray-900 aarni-font">Terms and Conditions</h1>
    </div>
</div>

<section class="py-5 bg-gray-100 aarni-font">
    <div class="container mx-auto px-4">
        <div class="flex justify-center">
            <div class="w-full max-w-7xl">
                <div class="bg-white shadow-lg rounded-lg p-6">
                    <h5 class="text-lg font-semibold">Welcome to ARNI University, Bringing Ambitions to Life.</h5>
                    <p class="mt-2">
                        We are available on the link
                        <a href="https://arni.in/" class="text-blue-400 "> https://arni.in/ </a>.
                        <b>"We," "Us,"</b> or <b>"Our"</b> refers to ARNI University, its subsidiaries, and affiliates.
                        <b>"You"</b> or <b>"User"</b> refers to any individual or entity accessing or using the website.
                        ‘Content’ means all audio/video work available on the website regarding ARNI University.
                    </p>

                    <p class="mt-2">
                        We are pleased to have you on the ARNI website and are committed to ensuring that your experience
                        on this platform will be secure, beneficial, and seamless. These ‘Terms and Conditions’ govern
                        your use of our website and its services. By accessing the ARNI website, you agree to comply with
                        these Terms. If you do not agree with any part of these Terms, please refrain from using our website.
                    </p>

                    <h5 class="text-lg font-semibold mt-4">Use of ARNI University Website</h5>
                    <p class="mt-2">
                        The content, pages, and information on the website are free and intended only for general
                        information. While we strive for accuracy, the material may change without prior notice.
                    </p>

                    <p class="mt-2">
                        The website and its services are intended solely for lawful purposes. You agree to use the website
                        in compliance with all applicable laws and regulations. Personal, educational, or non-commercial use
                        is permitted, but any other use requires written consent from ARNI University.
                    </p>

                    <h5 class="text-lg font-semibold mt-4">Prohibited Actions</h5>
                    <p class="mt-2">
                        It is prohibited to engage in activities that disrupt website functionality or security. Uploading,
                        sharing, or transmitting harmful, defamatory, or illegal content is restricted. Unauthorized access
                        attempts or data extraction via automated tools are also prohibited.
                    </p>
                    <p class="mt-2 font-semibold">Note: Any misuse or violation of these Terms may result in suspension or termination of access.</p>

                    <h5 class="text-lg font-semibold mt-4">Intellectual Property Rights</h5>
                    <p class="mt-2">
                        All content, including images, text, videos, graphics, logos, and software, is the property of
                        ARNI University and is protected under copyright and trademark laws.
                    </p>
                    <p class="mt-2">
                        Without written consent, you may not modify, reproduce, or distribute any content for commercial
                        purposes. If you believe any content infringes upon your intellectual property rights, please
                        contact us for investigation.
                    </p>

                    <h5 class="text-lg font-semibold mt-4">User Accounts</h5>
                    <p class="mt-2">
                        Certain services may require account registration. Users must provide accurate, complete, and updated
                        information. False details may result in account suspension or termination. Users are responsible
                        for maintaining account confidentiality.
                    </p>
                    <p class="mt-2 font-semibold">Note: ARNI reserves the right to suspend or terminate accounts involved in fraudulent activity.</p>

                    <h5 class="text-lg font-semibold mt-4">Third-party Links</h5>
                    <p class="mt-2">
                        Our website may contain third-party links for convenience. ARNI University does not control or
                        endorse the content of these external sites. Users should review their policies before engaging.
                    </p>

                    <h5 class="text-lg font-semibold mt-4">Website Access</h5>
                    <p class="mt-2">
                        While we strive for accuracy, we do not guarantee uninterrupted website access. Technical issues,
                        delays, or external factors may affect performance.
                    </p>

                    <h5 class="text-lg font-semibold mt-4">Indemnification</h5>
                    <p class="mt-2">
                        By using our website, you agree to indemnify and hold harmless ARNI University from any claims,
                        damages, or liabilities arising from:
                    </p>
                    <ul class="list-disc pl-6 mt-2 space-y-1">
                        <li>Your use of the website.</li>
                        <li>Your violation of these Terms.</li>
                        <li>Your infringement of any third-party rights.</li>
                    </ul>

                    <h5 class="text-lg font-semibold mt-4">Privacy Policy</h5>
                    <p class="mt-2">
                        To learn more about how we collect, use, and safeguard your data, check out our
                        <a href="/privacy-policy" class="text-blue-400 font-medium">Privacy Policy</a>.
                    </p>

                    <h5 class="text-lg font-semibold mt-4">Changes to Terms and Conditions</h5>
                    <p class="mt-2">
                        ARNI University reserves the right to modify these Terms at any time. Updates will be posted on
                        this page with the "Last Updated" date.
                    </p>
                    <p class="mt-2 font-semibold">Note: Your continued use of the website after any changes signifies your acceptance of the revised Terms.</p>

                    <h5 class="text-lg font-semibold mt-4">Contact Us</h5>
                    <p class="mt-2">
                        For any questions or concerns, feel free to contact us:
                    </p>
                    <p class="mt-2">
                        <span class="font-semibold">ARNI University Website:</span>
                        <a href="https://arni.in/" class="text-blue-400 font-medium"> arni.in</a>,
                        <span class="font-semibold"> Email:</span>
                        <a href="mailto:info@arniuniversity.edu.in" class="text-blue-400 font-medium"> info@arniuniversity.edu.in </a>,
                        <span class="font-semibold"> Phone:</span>
                        <a href="tel:18008918962" class="text-blue-400 font-medium"> 18008918962 </a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
